<template>
    <div>
        <LoadingOverlay :loading="loading" />
        <div class="topThreeRewards-box">
            <div class="rewardsBoxes">
                <div class="rewardsBox">
                    <div class="rewardsBox-In" @click="redirectProfile(RichThisweekData[1].id, RichThisweekData[1].profile_id, RichThisweekData[1].rich_level)">
                        <div class="rewardsProfile-imageBox">
                            <img :src='ProfileFrame2' class="profile-imgFrame" alt="pf-frame" />
                            <div class="profile-imageBox" v-if="RichThisweekData.length > 1">
                                <img class="overlapImg" :src='RichThisweekData[1].profile_images[0].image_name'
                                    alt="User Image" />
                            </div>
                            <div class="rewards-level" v-if="RichThisweekData.length > 1">
                                <img :src="getLevelImage(RichThisweekData[1].rich_level)" class="lavelImage"
                                    alt="level icon" />
                                <span class="lavel-value">{{
                                RichThisweekData[1].rich_level }}</span>
                            </div>
                        </div>
                        <div class="userName-box">
                            <div class="userName" v-if="RichThisweekData.length > 1">{{ RichThisweekData[1].name }}
                            </div>
                            <div class="beansBox">
                                <img :src='diamondIcon' class="diamondIcon" alt="" />
                                <span class="beansValue" v-if="RichThisweekData.length > 1">{{
                                RichThisweekData[1].weekly_spend_beans
                            }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="rewardsBox center-rewardsBox">
                    <div class="rewardsBox-In" @click="redirectProfile(RichThisweekData[0].id, RichThisweekData[0].profile_id, RichThisweekData[0].rich_level)">
                        <div class="rewardsProfile-imageBox">
                            <img :src='ProfileFrame1' class="profile-imgFrame" alt="pf-frame" />
                            <div class="profile-imageBox" v-if="RichThisweekData.length > 0">
                                <img class="overlapImg" :src='RichThisweekData[0].profile_images[0].image_name'
                                    alt="User Image" />
                            </div>
                            <div class="rewards-level" v-if="RichThisweekData.length > 0">
                                <img :src="getLevelImage(RichThisweekData[0].rich_level)" class="lavelImage"
                                    alt="level icon" />
                                <span class="lavel-value">{{ RichThisweekData[0].rich_level }}</span>
                            </div>
                        </div>
                        <div class="userName-box">
                            <div class="userName" v-if="RichThisweekData.length > 0">{{ RichThisweekData[0].name }}
                            </div>
                            <div class="beansBox">
                                <img :src='diamondIcon' class="diamondIcon" alt="" />
                                <span class="beansValue" v-if="RichThisweekData.length > 0">{{
                                RichThisweekData[0].weekly_spend_beans
                            }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="rewardsBox">
                    <div class="rewardsBox-In" @click="redirectProfile(RichThisweekData[2].id, RichThisweekData[2].profile_id, RichThisweekData[2].rich_level)">
                        <div class="rewardsProfile-imageBox">
                            <img :src='ProfileFrame3' class="profile-imgFrame" alt="pf-frame" />
                            <div class="profile-imageBox" v-if="RichThisweekData.length > 2">
                                <img class="overlapImg" :src='RichThisweekData[2].profile_images[0].image_name'
                                    alt="User Image" />
                            </div>
                            <div class="rewards-level" v-if="RichThisweekData.length > 2">
                                <img :src="getLevelImage(RichThisweekData[2].rich_level)" class="lavelImage"
                                    alt="level icon" />
                                <span class="lavel-value">{{ RichThisweekData[2].rich_level }}</span>
                            </div>
                        </div>
                        <div class="userName-box">
                            <div class="userName" v-if="RichThisweekData.length > 2">{{ RichThisweekData[2].name }}
                            </div>
                            <div class="beansBox">
                                <img :src='diamondIcon' class="diamondIcon" alt="" />
                                <span class="beansValue" v-if="RichThisweekData.length > 2">{{
                                RichThisweekData[2].weekly_spend_beans
                            }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="podiumImageBox">
                <img class="podiumImage" :src='podiumImage' alt="Podium Image" />
            </div>
        </div>
        <div class="fixHeight ringlive-datalistWrap">
            <div class="listBoxes" v-for="(reward, index) in RichThisweekData.slice(3) " :key="reward.id"
            @click="redirectProfile(reward.id, reward.profile_id, reward.rich_level)">
                <div class="leftBxb">
                    <div class="s-no">{{ index + 4 }}</div>
                    <div class="listIconBox">
                        <div class="profPic">
                            <img :src='(reward.profile_images.length > 0) ? reward.profile_images[0].image_name : defaultUserImage'
                                alt="User Image" />
                        </div>
                    </div>
                    <div class="name-lavel-box">
                        <div class="userName">{{ reward.name }}</div>
                        <div class="lavel-box">
                            <img :src="getLevelImage(reward.rich_level)" class="lavelImage" alt="level icon" />
                            <span class="lavel-value">{{ reward.rich_level }}</span>
                        </div>
                    </div>
                </div>
                <div class="rightBox">
                    <div class="rightBox-in">
                        <img :src='diamondIcon' class="diamondIcon" alt="beans icons" />
                        {{ reward.weekly_spend_beans }}
                    </div>
                </div>
            </div>
        </div>
        <div v-if="personalDetails" class="listBoxes myselfBox" @click="redirectProfile(personalDetails.id, personalDetails.profile_id, personalDetails.rich_level)">
            <div class="leftBxb">
                <div class="s-no">-</div>
                <div class="listIconBox">
                    <div class="profPic">
                        <!-- <img :src='(personalDetails.profile_images.length > 0) ? personalDetails.profile_images[0].image_name : defaultUserImage'
                            alt="User Image" /> -->
                        <img :src="personalDetails.profile_images.length > 0 ? personalDetails.profile_images[0].image_name : defaultUserImage"
                            alt="User Image" @error="setDefaultImage" />
                    </div>
                </div>
                <div class="name-lavel-box">
                    <div class="userName">{{ personalDetails.name }}</div>
                    <div class="lavel-box">
                        <img :src="getLevelImage(personalDetails.rich_level) " class="lavelImage" alt="level icon" />
                        <span class="lavel-value">{{ personalDetails.rich_level }}</span>
                    </div>
                </div>
            </div>
            <div class="rightBox">
                <div class="rightBox-in"><img :src='diamondIcon' class="diamondIcon" alt="diamond icons" />{{
                    personalDetails.weekly_spend_beans }}</div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios'
import ProfileFrame1 from '../../assets/images/rank1-frameImage.png'
import ProfileFrame2 from '../../assets/images/rank2-frameImage.png'
import ProfileFrame3 from '../../assets/images/rank3-frameImage.png'
import diamondIcon from '../../assets/images/diamond-icon.png'
import podiumImage from '../../assets/images/podium-background.webp'
import defaultUserImage from '../../assets/images/default_profile.webp';
import LoadingOverlay from '../LoadingOverlay.vue'
export default {
    name: 'RichThisWeekTabCont',
    components: {
        LoadingOverlay
    },
    data() {
        return {
            RichThisweekData: [],
            personalDetails: null,
            ProfileFrame1: ProfileFrame1,
            ProfileFrame2: ProfileFrame2,
            ProfileFrame3: ProfileFrame3,
            diamondIcon: diamondIcon,
            podiumImage: podiumImage,
            defaultUserImage: defaultUserImage,
            loading: false,
        }
    },
    watch: {
        '$route.params.profile_id': 'fetchRichThisweekData'
    },
    mounted() {
        this.fetchRichThisweekData();
    },
    methods: {
        fetchRichThisweekData() {
            this.loading= true;
            const tokenParam = this.$route.params.token;
            const token = tokenParam.split('=')[0];
            const apiUrl = `api/top-rich-weekly?type=this_week`;
            axios.get(apiUrl, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            })
                .then(response => {
                    this.RichThisweekData = response.data.result.data;
                    this.personalDetails = response.data.result.personal_details;
                    this.checkAllImagesExist();
                })

                .catch(error => {
                    console.error("Error Featching This Week Data", error)
                })
                .finally(() => {
                    this.loading = false;
                })
        },
        getLevelImage(rich_lavel) {
            switch (true) {
                case rich_lavel === 0:
                    return require('@/assets/images/rich-lavel-0.png');
                case rich_lavel === 1:
                    return require('@/assets/images/rich-lavel-1.png');
                case rich_lavel === 2:
                    return require('@/assets/images/rich-lavel-2.png');
                case rich_lavel === 3:
                    return require('@/assets/images/rich-lavel-3.png');
                case rich_lavel === 4:
                    return require('@/assets/images/rich-lavel-4.png');
                case rich_lavel >= 5 && rich_lavel <= 8:
                    return require('@/assets/images/rich-lavel-5-8.png');
                case rich_lavel >= 9 && rich_lavel <= 11:
                    return require('@/assets/images/rich-lavel-9-11.png');
                case rich_lavel === 12:
                    return require('@/assets/images/rich-lavel-12.png');
                case rich_lavel === 13:
                    return require('@/assets/images/rich-lavel-13.png');
                case rich_lavel === 14:
                    return require('@/assets/images/rich-lavel-14.png');
                case rich_lavel === 15:
                    return require('@/assets/images/rich-lavel-15.png');
                default:
                    return require('@/assets/images/rich-lavel-0.png');
            }
        },
        checkAllImagesExist() {
            this.RichThisweekData.forEach(reward => {
                if (reward.profile_images.length > 0) {
                    const imageUrl = reward.profile_images[0].image_name;
                    this.checkImageExists(imageUrl)
                        .then(exists => {
                            if (!exists) {
                                reward.profile_images[0].image_name = this.defaultUserImage;
                            }
                        });
                } else {
                    reward.profile_images = [{ image_name: this.defaultUserImage }];
                }

                
            });
        },
        checkImageExists(imageUrl) {
            return new Promise((resolve) => {
                var img = new Image();
                img.onload = function () {
                    resolve(true);
                };
                img.onerror = function () {
                    resolve(false);
                };
                img.src = imageUrl;
            });
        },

        setDefaultImage(event) {
            event.target.src = this.defaultUserImage;
        },
        
        redirectProfile(id, profile_id, level) {
            if (window.navigator.userAgent.indexOf("Android") > -1) {
                const baseURL = 'female-weekly-rewards';
                const params = {
                    id: id,
                    profile_id: profile_id,
                    level: level
                };
                const queryString = Object.keys(params)
                    .map(key => `${key}=${params[key]}`)
                    .join('&');
                const url = `${baseURL}?${queryString}`;
                //console.warn(url)
                Android.redirectProfile(url);
            }
        }
    },
}
</script>